export default __webpack_public_path__ + "static/media/class_x_engg_tab.df2dfcb4.png";